
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16"
  },
  "children": [
    {
      "tag": "g",
      "attrsMap": {
        "fill": "none",
        "fill-rule": "evenodd"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "fill-rule": "nonzero"
          },
          "children": [
            {
              "tag": "g",
              "children": [
                {
                  "tag": "g",
                  "children": [
                    {
                      "tag": "path",
                      "attrsMap": {
                        "d": "M10.89 4c2.248 0 3.777 1.53 3.777 3.953 0 .747-.331 1.604-1.105 2.657l-.088.118-.14.182-.073.092-.076.093-.157.19-.04.047-.042.048-.17.196-.18.2-.188.203-.197.209-.207.212-.053.054-.054.055-.221.22-.231.223-.24.23-.062.058-.062.058-.256.237-.265.241-.275.247-.286.251-.296.257-1.45 1.242L8 16l-.253-.227-1.298-1.111c-3.73-3.193-5.116-5.18-5.116-6.709C1.333 5.53 2.862 4 5.11 4 6.147 4 7.051 4.477 8 5.387 8.95 4.477 9.853 4 10.89 4zm0 1.02c-.776 0-2.135.64-2.446 1.703l-.022.085h-.748C7.258 5.699 5.906 5.02 5.11 5.02c-1.7 0-2.77.886-2.77 2.747 0 1.636 1.314 3.147 4.843 6.169l.817.7.818-.7.441-.38.281-.245.402-.355.255-.228.363-.33.23-.213.22-.207.21-.202.2-.196.19-.191.047-.048.045-.046.177-.185.167-.18.041-.044.04-.044.154-.174.037-.043.037-.042.14-.168.1-.124.095-.122.119-.16c.594-.817.852-1.517.852-2.242 0-1.861-1.072-2.747-2.771-2.747zM8.495 8v1.49H10v1H8.495V12h-1v-1.51H6v-1h1.495V8h1z",
                        "transform": "translate(-393 -134) translate(256 125) translate(137 9)"
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
})
    }
  